import React from 'react';
import {useTranslation} from "react-i18next";

const useKazakhstan = () => {

    const {t} = useTranslation();

    const kazakhstan = {
        "title": "Kazakhstan",
        "version": "2.1.0",
        "type": "FeatureCollection",
        "copyright": "Copyright (c) 2023 Highsoft AS, Based on data from Natural Earth",
        "copyrightShort": "Natural Earth",
        "copyrightUrl": "http://www.naturalearthdata.com",
        "crs": {
            "type": "name",
            "properties": {
                "name": "urn:ogc:def:crs:EPSG:54003"
            }
        },
        "hc-transform": {
            "default": {
                "crs": "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs",
                "scale": 0.000154127157066,
                "jsonres": 15.5,
                "jsonmarginX": -999,
                "jsonmarginY": 9851.0,
                "xoffset": 5168269.55578,
                "yoffset": 6863579.41101
            }
        },
        "features": [
            {
                "type": "Feature",
                "id": "KZ.5085",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.56,
                    "hc-middle-y": 0.62,
                    "hc-key": "kz-5085",
                    "hc-a2": "NU",
                    "labelrank": "20",
                    "hasc": "-99",
                    "alt-name": null,
                    "woe-id": "-99",
                    "subregion": null,
                    "fips": null,
                    "postal-code": null,
                    "name": null,
                    "country": "Kazakhstan",
                    "type-en": null,
                    "region": null,
                    "longitude": "50.5921",
                    "woe-name": null,
                    "latitude": "44.8058",
                    "woe-label": null,
                    "type": null
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                732,
                                6678
                            ],
                            [
                                719,
                                6674
                            ],
                            [
                                735,
                                6695
                            ],
                            [
                                739,
                                6691
                            ],
                            [
                                732,
                                6678
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.QO",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.52,
                    "hc-middle-y": 0.51,
                    "hc-key": "kz-qo",
                    "hc-a2": "QO",
                    "labelrank": "6",
                    "hasc": "KZ.QO",
                    "alt-name": "Kyzyl-Orda|Kzyl-Orda|Kzyl-Ordinskaya Oblast'",
                    "woe-id": "2345990",
                    "subregion": null,
                    "fips": "KZ14",
                    "postal-code": "QO",
                    "name": t('region.qyzylorda.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "63.6151",
                    "woe-name": "Qyzylorda",
                    "latitude": "44.6012",
                    "woe-label": "Qyzylorda, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [
                        [
                            [
                                [
                                    2704,
                                    6546
                                ],
                                [
                                    2707,
                                    6522
                                ],
                                [
                                    2616,
                                    6552
                                ],
                                [
                                    2655,
                                    6560
                                ],
                                [
                                    2704,
                                    6546
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    2335,
                                    6477
                                ],
                                [
                                    2335,
                                    6477
                                ],
                                [
                                    2335,
                                    6477
                                ],
                                [
                                    2335,
                                    6477
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    2336,
                                    6447
                                ],
                                [
                                    2353,
                                    6487
                                ],
                                [
                                    2434,
                                    6399
                                ],
                                [
                                    2430,
                                    6364
                                ],
                                [
                                    2449,
                                    6304
                                ],
                                [
                                    2445,
                                    6265
                                ],
                                [
                                    2342,
                                    6326
                                ],
                                [
                                    2336,
                                    6447
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    4190,
                                    5370
                                ],
                                [
                                    4201,
                                    5391
                                ],
                                [
                                    4213,
                                    5567
                                ],
                                [
                                    4132,
                                    5531
                                ],
                                [
                                    4058,
                                    5666
                                ],
                                [
                                    3993,
                                    5705
                                ],
                                [
                                    3909,
                                    5795
                                ],
                                [
                                    3882,
                                    5800
                                ],
                                [
                                    3769,
                                    5747
                                ],
                                [
                                    3445,
                                    5773
                                ],
                                [
                                    3131,
                                    5725
                                ],
                                [
                                    3120,
                                    5729
                                ],
                                [
                                    2901,
                                    5948
                                ],
                                [
                                    2868,
                                    6018
                                ],
                                [
                                    2608,
                                    6169
                                ],
                                [
                                    2615,
                                    6339
                                ],
                                [
                                    2598,
                                    6408
                                ],
                                [
                                    2535,
                                    6408
                                ],
                                [
                                    2524,
                                    6448
                                ],
                                [
                                    2583,
                                    6522
                                ],
                                [
                                    2703,
                                    6496
                                ],
                                [
                                    2806,
                                    6591
                                ],
                                [
                                    2912,
                                    6625
                                ],
                                [
                                    2931,
                                    6699
                                ],
                                [
                                    2840,
                                    6709
                                ],
                                [
                                    2799,
                                    6745
                                ],
                                [
                                    2808,
                                    6798
                                ],
                                [
                                    2742,
                                    6811
                                ],
                                [
                                    2798,
                                    6770
                                ],
                                [
                                    2768,
                                    6744
                                ],
                                [
                                    2719,
                                    6756
                                ],
                                [
                                    2703,
                                    6714
                                ],
                                [
                                    2680,
                                    6779
                                ],
                                [
                                    2652,
                                    6780
                                ],
                                [
                                    2592,
                                    6735
                                ],
                                [
                                    2596,
                                    6696
                                ],
                                [
                                    2628,
                                    6673
                                ],
                                [
                                    2686,
                                    6690
                                ],
                                [
                                    2744,
                                    6653
                                ],
                                [
                                    2779,
                                    6685
                                ],
                                [
                                    2811,
                                    6632
                                ],
                                [
                                    2804,
                                    6598
                                ],
                                [
                                    2761,
                                    6571
                                ],
                                [
                                    2600,
                                    6592
                                ],
                                [
                                    2543,
                                    6570
                                ],
                                [
                                    2538,
                                    6645
                                ],
                                [
                                    2465,
                                    6655
                                ],
                                [
                                    2521,
                                    6574
                                ],
                                [
                                    2493,
                                    6489
                                ],
                                [
                                    2440,
                                    6446
                                ],
                                [
                                    2388,
                                    6465
                                ],
                                [
                                    2403,
                                    6554
                                ],
                                [
                                    2347,
                                    6534
                                ],
                                [
                                    2357,
                                    6570
                                ],
                                [
                                    2505,
                                    6741
                                ],
                                [
                                    2572,
                                    6801
                                ],
                                [
                                    2638,
                                    6843
                                ],
                                [
                                    2702,
                                    6856
                                ],
                                [
                                    2736,
                                    6919
                                ],
                                [
                                    2796,
                                    6915
                                ],
                                [
                                    2863,
                                    7003
                                ],
                                [
                                    2887,
                                    7059
                                ],
                                [
                                    2945,
                                    7128
                                ],
                                [
                                    3011,
                                    7142
                                ],
                                [
                                    3086,
                                    7143
                                ],
                                [
                                    3137,
                                    7073
                                ],
                                [
                                    3209,
                                    7031
                                ],
                                [
                                    3243,
                                    6965
                                ],
                                [
                                    3348,
                                    6943
                                ],
                                [
                                    3297,
                                    6898
                                ],
                                [
                                    3376,
                                    6908
                                ],
                                [
                                    3445,
                                    6869
                                ],
                                [
                                    3549,
                                    6837
                                ],
                                [
                                    3607,
                                    6831
                                ],
                                [
                                    3924,
                                    6720
                                ],
                                [
                                    3947,
                                    6718
                                ],
                                [
                                    4012,
                                    6668
                                ],
                                [
                                    4068,
                                    6645
                                ],
                                [
                                    4447,
                                    6567
                                ],
                                [
                                    4518,
                                    6568
                                ],
                                [
                                    4525,
                                    6535
                                ],
                                [
                                    4529,
                                    6503
                                ],
                                [
                                    4568,
                                    6449
                                ],
                                [
                                    4548,
                                    6419
                                ],
                                [
                                    4530,
                                    6302
                                ],
                                [
                                    4610,
                                    6243
                                ],
                                [
                                    4613,
                                    5994
                                ],
                                [
                                    4682,
                                    5963
                                ],
                                [
                                    4709,
                                    5926
                                ],
                                [
                                    4772,
                                    5884
                                ],
                                [
                                    4772,
                                    5863
                                ],
                                [
                                    4730,
                                    5844
                                ],
                                [
                                    4729,
                                    5785
                                ],
                                [
                                    4701,
                                    5798
                                ],
                                [
                                    4674,
                                    5706
                                ],
                                [
                                    4651,
                                    5687
                                ],
                                [
                                    4682,
                                    5674
                                ],
                                [
                                    4698,
                                    5622
                                ],
                                [
                                    4568,
                                    5566
                                ],
                                [
                                    4439,
                                    5490
                                ],
                                [
                                    4382,
                                    5445
                                ],
                                [
                                    4318,
                                    5435
                                ],
                                [
                                    4235,
                                    5363
                                ],
                                [
                                    4190,
                                    5370
                                ]
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.AC",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.53,
                    "hc-middle-y": 0.50,
                    "hc-key": "kz-ac",
                    "hc-a2": "AC",
                    "labelrank": "6",
                    "hasc": "KZ.AC",
                    "alt-name": "Alma-Ata",
                    "woe-id": "20070179",
                    "subregion": null,
                    "fips": "KZ02",
                    "postal-code": "AC",
                    "name": t('city.almaty'),
                    "country": "Kazakhstan",
                    "type-en": "City",
                    "region": null,
                    "longitude": "76.94240000000001",
                    "woe-name": "Almaty",
                    "latitude": "43.2709",
                    "woe-label": "Almaty, KZ, Kazakhstan",
                    "type": null
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                7109,
                                5642
                            ],
                            [
                                7067,
                                5635
                            ],
                            [
                                7058,
                                5658
                            ],
                            [
                                7083,
                                5688
                            ],
                            [
                                7117,
                                5692
                            ],
                            [
                                7109,
                                5642
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.AS",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.52,
                    "hc-middle-y": 0.46,
                    "hc-key": "kz-as",
                    "hc-a2": "AS",
                    "labelrank": "4",
                    "hasc": "KZ.AS",
                    "alt-name": null,
                    "woe-id": "20070181",
                    "subregion": null,
                    "fips": "KZ05",
                    "postal-code": "AS",
                    "name": t('city.astana'),
                    "country": "Kazakhstan",
                    "type-en": "City",
                    "region": null,
                    "longitude": "71.4538",
                    "woe-name": "Astana",
                    "latitude": "51.1503",
                    "woe-label": "Astana, KZ, Kazakhstan",
                    "type": null
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                5655,
                                8249
                            ],
                            [
                                5639,
                                8243
                            ],
                            [
                                5581,
                                8306
                            ],
                            [
                                5598,
                                8353
                            ],
                            [
                                5628,
                                8357
                            ],
                            [
                                5676,
                                8308
                            ],
                            [
                                5655,
                                8249
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.QS",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.49,
                    "hc-middle-y": 0.43,
                    "hc-key": "kz-qs",
                    "hc-a2": "QS",
                    "labelrank": "6",
                    "hasc": "KZ.QS",
                    "alt-name": "Kustanai|Kustanay",
                    "woe-id": "20070176",
                    "subregion": null,
                    "fips": "KZ13",
                    "postal-code": "QS",
                    "name": t('region.qostanay.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "64.12909999999999",
                    "woe-name": "Qostanay",
                    "latitude": "51.2854",
                    "woe-label": "Qostanay, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                3030,
                                8344
                            ],
                            [
                                2984,
                                8401
                            ],
                            [
                                2864,
                                8422
                            ],
                            [
                                2842,
                                8467
                            ],
                            [
                                2729,
                                8469
                            ],
                            [
                                2687,
                                8488
                            ],
                            [
                                2720,
                                8528
                            ],
                            [
                                2629,
                                8565
                            ],
                            [
                                2603,
                                8559
                            ],
                            [
                                2594,
                                8602
                            ],
                            [
                                2647,
                                8602
                            ],
                            [
                                2727,
                                8658
                            ],
                            [
                                2771,
                                8655
                            ],
                            [
                                2869,
                                8723
                            ],
                            [
                                2844,
                                8775
                            ],
                            [
                                2814,
                                8787
                            ],
                            [
                                2806,
                                8828
                            ],
                            [
                                2772,
                                8841
                            ],
                            [
                                2874,
                                8933
                            ],
                            [
                                2852,
                                8951
                            ],
                            [
                                2909,
                                8966
                            ],
                            [
                                2985,
                                8966
                            ],
                            [
                                3019,
                                8943
                            ],
                            [
                                3076,
                                8954
                            ],
                            [
                                3103,
                                8939
                            ],
                            [
                                3149,
                                8959
                            ],
                            [
                                3137,
                                9006
                            ],
                            [
                                3061,
                                9022
                            ],
                            [
                                3029,
                                9049
                            ],
                            [
                                2985,
                                9039
                            ],
                            [
                                2912,
                                9061
                            ],
                            [
                                2895,
                                9096
                            ],
                            [
                                2916,
                                9139
                            ],
                            [
                                2968,
                                9119
                            ],
                            [
                                3006,
                                9144
                            ],
                            [
                                2992,
                                9174
                            ],
                            [
                                2942,
                                9158
                            ],
                            [
                                2896,
                                9165
                            ],
                            [
                                2860,
                                9191
                            ],
                            [
                                2912,
                                9258
                            ],
                            [
                                2852,
                                9281
                            ],
                            [
                                2863,
                                9305
                            ],
                            [
                                2914,
                                9290
                            ],
                            [
                                2910,
                                9330
                            ],
                            [
                                2969,
                                9344
                            ],
                            [
                                3018,
                                9305
                            ],
                            [
                                3076,
                                9321
                            ],
                            [
                                3125,
                                9299
                            ],
                            [
                                3125,
                                9330
                            ],
                            [
                                3234,
                                9333
                            ],
                            [
                                3228,
                                9302
                            ],
                            [
                                3256,
                                9279
                            ],
                            [
                                3270,
                                9333
                            ],
                            [
                                3340,
                                9358
                            ],
                            [
                                3412,
                                9355
                            ],
                            [
                                3422,
                                9387
                            ],
                            [
                                3478,
                                9383
                            ],
                            [
                                3578,
                                9415
                            ],
                            [
                                3617,
                                9397
                            ],
                            [
                                3657,
                                9407
                            ],
                            [
                                3650,
                                9434
                            ],
                            [
                                3809,
                                9464
                            ],
                            [
                                3847,
                                9445
                            ],
                            [
                                3897,
                                9470
                            ],
                            [
                                3944,
                                9436
                            ],
                            [
                                3977,
                                9449
                            ],
                            [
                                3978,
                                9516
                            ],
                            [
                                4034,
                                9525
                            ],
                            [
                                4040,
                                9553
                            ],
                            [
                                4110,
                                9542
                            ],
                            [
                                4169,
                                9580
                            ],
                            [
                                4181,
                                9547
                            ],
                            [
                                4212,
                                9556
                            ],
                            [
                                4247,
                                9432
                            ],
                            [
                                4216,
                                9420
                            ],
                            [
                                4285,
                                9361
                            ],
                            [
                                4192,
                                9321
                            ],
                            [
                                4212,
                                9255
                            ],
                            [
                                4248,
                                9230
                            ],
                            [
                                4218,
                                9171
                            ],
                            [
                                4229,
                                9140
                            ],
                            [
                                4263,
                                9134
                            ],
                            [
                                4273,
                                9054
                            ],
                            [
                                4312,
                                9011
                            ],
                            [
                                4230,
                                8990
                            ],
                            [
                                4215,
                                8965
                            ],
                            [
                                4235,
                                8926
                            ],
                            [
                                4211,
                                8864
                            ],
                            [
                                4201,
                                8747
                            ],
                            [
                                4196,
                                8668
                            ],
                            [
                                4175,
                                8647
                            ],
                            [
                                4149,
                                8567
                            ],
                            [
                                4109,
                                8530
                            ],
                            [
                                4039,
                                8517
                            ],
                            [
                                4035,
                                8496
                            ],
                            [
                                4092,
                                8447
                            ],
                            [
                                4078,
                                8383
                            ],
                            [
                                4055,
                                8343
                            ],
                            [
                                4062,
                                8310
                            ],
                            [
                                4109,
                                8242
                            ],
                            [
                                4112,
                                8179
                            ],
                            [
                                4147,
                                8182
                            ],
                            [
                                4202,
                                8215
                            ],
                            [
                                4243,
                                8171
                            ],
                            [
                                4270,
                                8172
                            ],
                            [
                                4313,
                                8134
                            ],
                            [
                                4408,
                                8107
                            ],
                            [
                                4485,
                                8118
                            ],
                            [
                                4514,
                                8099
                            ],
                            [
                                4502,
                                8053
                            ],
                            [
                                4541,
                                8018
                            ],
                            [
                                4611,
                                8047
                            ],
                            [
                                4680,
                                8055
                            ],
                            [
                                4743,
                                8079
                            ],
                            [
                                4790,
                                8046
                            ],
                            [
                                4747,
                                7995
                            ],
                            [
                                4653,
                                7969
                            ],
                            [
                                4655,
                                7913
                            ],
                            [
                                4592,
                                7845
                            ],
                            [
                                4364,
                                7672
                            ],
                            [
                                4229,
                                7559
                            ],
                            [
                                4176,
                                7553
                            ],
                            [
                                4116,
                                7511
                            ],
                            [
                                4060,
                                7501
                            ],
                            [
                                3940,
                                7516
                            ],
                            [
                                3852,
                                7504
                            ],
                            [
                                3821,
                                7441
                            ],
                            [
                                3790,
                                7440
                            ],
                            [
                                3801,
                                7389
                            ],
                            [
                                3713,
                                7355
                            ],
                            [
                                3711,
                                7320
                            ],
                            [
                                3647,
                                7269
                            ],
                            [
                                3565,
                                7378
                            ],
                            [
                                3397,
                                7453
                            ],
                            [
                                3398,
                                7512
                            ],
                            [
                                3300,
                                7517
                            ],
                            [
                                3243,
                                7576
                            ],
                            [
                                3223,
                                7616
                            ],
                            [
                                3253,
                                7637
                            ],
                            [
                                3202,
                                7711
                            ],
                            [
                                3209,
                                7739
                            ],
                            [
                                3244,
                                7737
                            ],
                            [
                                3234,
                                7765
                            ],
                            [
                                3286,
                                7853
                            ],
                            [
                                3314,
                                7871
                            ],
                            [
                                3366,
                                7867
                            ],
                            [
                                3360,
                                7911
                            ],
                            [
                                3308,
                                7980
                            ],
                            [
                                3266,
                                8055
                            ],
                            [
                                3242,
                                8138
                            ],
                            [
                                3205,
                                8165
                            ],
                            [
                                3224,
                                8199
                            ],
                            [
                                3187,
                                8232
                            ],
                            [
                                3202,
                                8265
                            ],
                            [
                                3165,
                                8290
                            ],
                            [
                                3132,
                                8274
                            ],
                            [
                                3090,
                                8355
                            ],
                            [
                                3030,
                                8344
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.NK",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.25,
                    "hc-middle-y": 0.52,
                    "hc-key": "kz-nk",
                    "hc-a2": "NK",
                    "labelrank": "4",
                    "hasc": "KZ.NK",
                    "alt-name": "Severo-Kazakhstan|Soltustik Qazaqstan",
                    "woe-id": "20070174",
                    "subregion": null,
                    "fips": "KZ16",
                    "postal-code": "NK",
                    "name": t('region.north-kaz.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "69.0682",
                    "woe-name": "North Kazakhstan",
                    "latitude": "54.4528",
                    "woe-label": "Soltustik Qazaqstan, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                4201,
                                8747
                            ],
                            [
                                4211,
                                8864
                            ],
                            [
                                4235,
                                8926
                            ],
                            [
                                4215,
                                8965
                            ],
                            [
                                4230,
                                8990
                            ],
                            [
                                4312,
                                9011
                            ],
                            [
                                4273,
                                9054
                            ],
                            [
                                4263,
                                9134
                            ],
                            [
                                4229,
                                9140
                            ],
                            [
                                4218,
                                9171
                            ],
                            [
                                4248,
                                9230
                            ],
                            [
                                4212,
                                9255
                            ],
                            [
                                4192,
                                9321
                            ],
                            [
                                4285,
                                9361
                            ],
                            [
                                4216,
                                9420
                            ],
                            [
                                4247,
                                9432
                            ],
                            [
                                4212,
                                9556
                            ],
                            [
                                4305,
                                9584
                            ],
                            [
                                4509,
                                9615
                            ],
                            [
                                4528,
                                9636
                            ],
                            [
                                4618,
                                9636
                            ],
                            [
                                4669,
                                9672
                            ],
                            [
                                4762,
                                9674
                            ],
                            [
                                4800,
                                9717
                            ],
                            [
                                4768,
                                9736
                            ],
                            [
                                4787,
                                9762
                            ],
                            [
                                4879,
                                9762
                            ],
                            [
                                4904,
                                9824
                            ],
                            [
                                4963,
                                9792
                            ],
                            [
                                4968,
                                9851
                            ],
                            [
                                5016,
                                9837
                            ],
                            [
                                5033,
                                9811
                            ],
                            [
                                5072,
                                9833
                            ],
                            [
                                5162,
                                9814
                            ],
                            [
                                5226,
                                9768
                            ],
                            [
                                5301,
                                9739
                            ],
                            [
                                5348,
                                9764
                            ],
                            [
                                5366,
                                9795
                            ],
                            [
                                5467,
                                9799
                            ],
                            [
                                5460,
                                9776
                            ],
                            [
                                5509,
                                9719
                            ],
                            [
                                5500,
                                9649
                            ],
                            [
                                5516,
                                9607
                            ],
                            [
                                5563,
                                9590
                            ],
                            [
                                5582,
                                9552
                            ],
                            [
                                5554,
                                9540
                            ],
                            [
                                5565,
                                9439
                            ],
                            [
                                5509,
                                9442
                            ],
                            [
                                5526,
                                9391
                            ],
                            [
                                5563,
                                9360
                            ],
                            [
                                5600,
                                9397
                            ],
                            [
                                5641,
                                9363
                            ],
                            [
                                5703,
                                9372
                            ],
                            [
                                5717,
                                9414
                            ],
                            [
                                5769,
                                9409
                            ],
                            [
                                5801,
                                9377
                            ],
                            [
                                5808,
                                9437
                            ],
                            [
                                5839,
                                9445
                            ],
                            [
                                5860,
                                9388
                            ],
                            [
                                5909,
                                9373
                            ],
                            [
                                5877,
                                9345
                            ],
                            [
                                5879,
                                9300
                            ],
                            [
                                5901,
                                9289
                            ],
                            [
                                5955,
                                9339
                            ],
                            [
                                5916,
                                9339
                            ],
                            [
                                5946,
                                9373
                            ],
                            [
                                6035,
                                9366
                            ],
                            [
                                6063,
                                9316
                            ],
                            [
                                6142,
                                9301
                            ],
                            [
                                6184,
                                9307
                            ],
                            [
                                6202,
                                9347
                            ],
                            [
                                6243,
                                9344
                            ],
                            [
                                6231,
                                9287
                            ],
                            [
                                6175,
                                9278
                            ],
                            [
                                6107,
                                9201
                            ],
                            [
                                6107,
                                9168
                            ],
                            [
                                6166,
                                9123
                            ],
                            [
                                6199,
                                9067
                            ],
                            [
                                6166,
                                9055
                            ],
                            [
                                6175,
                                9008
                            ],
                            [
                                6220,
                                9041
                            ],
                            [
                                6250,
                                9031
                            ],
                            [
                                6190,
                                8940
                            ],
                            [
                                6228,
                                8945
                            ],
                            [
                                6217,
                                8900
                            ],
                            [
                                6250,
                                8894
                            ],
                            [
                                6269,
                                8924
                            ],
                            [
                                6320,
                                8909
                            ],
                            [
                                6287,
                                8832
                            ],
                            [
                                6242,
                                8861
                            ],
                            [
                                6249,
                                8831
                            ],
                            [
                                6303,
                                8806
                            ],
                            [
                                6221,
                                8812
                            ],
                            [
                                6173,
                                8842
                            ],
                            [
                                6036,
                                8876
                            ],
                            [
                                6018,
                                8960
                            ],
                            [
                                5995,
                                8968
                            ],
                            [
                                5898,
                                8959
                            ],
                            [
                                5844,
                                8928
                            ],
                            [
                                5760,
                                8930
                            ],
                            [
                                5709,
                                8966
                            ],
                            [
                                5734,
                                9032
                            ],
                            [
                                5676,
                                9098
                            ],
                            [
                                5598,
                                9066
                            ],
                            [
                                5541,
                                9080
                            ],
                            [
                                5531,
                                9110
                            ],
                            [
                                5428,
                                9104
                            ],
                            [
                                5391,
                                9048
                            ],
                            [
                                5330,
                                9093
                            ],
                            [
                                5279,
                                9092
                            ],
                            [
                                5292,
                                9140
                            ],
                            [
                                5241,
                                9137
                            ],
                            [
                                5230,
                                9190
                            ],
                            [
                                5160,
                                9208
                            ],
                            [
                                5090,
                                9169
                            ],
                            [
                                5044,
                                9203
                            ],
                            [
                                5016,
                                9184
                            ],
                            [
                                4947,
                                9187
                            ],
                            [
                                4957,
                                9162
                            ],
                            [
                                4873,
                                9106
                            ],
                            [
                                4936,
                                9049
                            ],
                            [
                                4963,
                                9002
                            ],
                            [
                                4934,
                                8948
                            ],
                            [
                                4945,
                                8889
                            ],
                            [
                                4871,
                                8853
                            ],
                            [
                                4840,
                                8810
                            ],
                            [
                                4774,
                                8788
                            ],
                            [
                                4778,
                                8749
                            ],
                            [
                                4725,
                                8698
                            ],
                            [
                                4638,
                                8737
                            ],
                            [
                                4576,
                                8740
                            ],
                            [
                                4572,
                                8688
                            ],
                            [
                                4491,
                                8678
                            ],
                            [
                                4370,
                                8693
                            ],
                            [
                                4357,
                                8718
                            ],
                            [
                                4269,
                                8710
                            ],
                            [
                                4249,
                                8735
                            ],
                            [
                                4201,
                                8747
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.PA",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.50,
                    "hc-middle-y": 0.60,
                    "hc-key": "kz-pa",
                    "hc-a2": "PA",
                    "labelrank": "6",
                    "hasc": "KZ.PA",
                    "alt-name": null,
                    "woe-id": "2345993",
                    "subregion": null,
                    "fips": "KZ11",
                    "postal-code": "PA",
                    "name": t('region.pavlodar.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "76.3751",
                    "woe-name": "Pavlodar",
                    "latitude": "52.2076",
                    "woe-label": "Pavlodar, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                6303,
                                8806
                            ],
                            [
                                6249,
                                8831
                            ],
                            [
                                6242,
                                8861
                            ],
                            [
                                6287,
                                8832
                            ],
                            [
                                6320,
                                8909
                            ],
                            [
                                6269,
                                8924
                            ],
                            [
                                6250,
                                8894
                            ],
                            [
                                6217,
                                8900
                            ],
                            [
                                6228,
                                8945
                            ],
                            [
                                6190,
                                8940
                            ],
                            [
                                6250,
                                9031
                            ],
                            [
                                6220,
                                9041
                            ],
                            [
                                6175,
                                9008
                            ],
                            [
                                6166,
                                9055
                            ],
                            [
                                6199,
                                9067
                            ],
                            [
                                6166,
                                9123
                            ],
                            [
                                6216,
                                9165
                            ],
                            [
                                6295,
                                9192
                            ],
                            [
                                6328,
                                9168
                            ],
                            [
                                6368,
                                9177
                            ],
                            [
                                6420,
                                9134
                            ],
                            [
                                6432,
                                9209
                            ],
                            [
                                6475,
                                9207
                            ],
                            [
                                6517,
                                9262
                            ],
                            [
                                6585,
                                9253
                            ],
                            [
                                6693,
                                9318
                            ],
                            [
                                6673,
                                9345
                            ],
                            [
                                6747,
                                9359
                            ],
                            [
                                6892,
                                9415
                            ],
                            [
                                6905,
                                9450
                            ],
                            [
                                6958,
                                9439
                            ],
                            [
                                7013,
                                9457
                            ],
                            [
                                7016,
                                9478
                            ],
                            [
                                7069,
                                9492
                            ],
                            [
                                7046,
                                9456
                            ],
                            [
                                7065,
                                9432
                            ],
                            [
                                7019,
                                9372
                            ],
                            [
                                6942,
                                9377
                            ],
                            [
                                6983,
                                9309
                            ],
                            [
                                7271,
                                9121
                            ],
                            [
                                7339,
                                9060
                            ],
                            [
                                7501,
                                8832
                            ],
                            [
                                7721,
                                8493
                            ],
                            [
                                7636,
                                8405
                            ],
                            [
                                7591,
                                8405
                            ],
                            [
                                7576,
                                8356
                            ],
                            [
                                7505,
                                8324
                            ],
                            [
                                7482,
                                8330
                            ],
                            [
                                7403,
                                8283
                            ],
                            [
                                7446,
                                8217
                            ],
                            [
                                7557,
                                8147
                            ],
                            [
                                7565,
                                8064
                            ],
                            [
                                7592,
                                8025
                            ],
                            [
                                7552,
                                7957
                            ],
                            [
                                7500,
                                7912
                            ],
                            [
                                7417,
                                7931
                            ],
                            [
                                7303,
                                7973
                            ],
                            [
                                7287,
                                7983
                            ],
                            [
                                7274,
                                8063
                            ],
                            [
                                7103,
                                8124
                            ],
                            [
                                7046,
                                8073
                            ],
                            [
                                7030,
                                7996
                            ],
                            [
                                6940,
                                7996
                            ],
                            [
                                6922,
                                7969
                            ],
                            [
                                6890,
                                7981
                            ],
                            [
                                6751,
                                7955
                            ],
                            [
                                6677,
                                7955
                            ],
                            [
                                6588,
                                7904
                            ],
                            [
                                6548,
                                7934
                            ],
                            [
                                6620,
                                7982
                            ],
                            [
                                6564,
                                8052
                            ],
                            [
                                6526,
                                8076
                            ],
                            [
                                6502,
                                8058
                            ],
                            [
                                6487,
                                8103
                            ],
                            [
                                6431,
                                8125
                            ],
                            [
                                6333,
                                8104
                            ],
                            [
                                6305,
                                8127
                            ],
                            [
                                6337,
                                8264
                            ],
                            [
                                6321,
                                8314
                            ],
                            [
                                6236,
                                8341
                            ],
                            [
                                6272,
                                8396
                            ],
                            [
                                6384,
                                8440
                            ],
                            [
                                6319,
                                8475
                            ],
                            [
                                6268,
                                8471
                            ],
                            [
                                6285,
                                8543
                            ],
                            [
                                6326,
                                8571
                            ],
                            [
                                6319,
                                8771
                            ],
                            [
                                6303,
                                8806
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.AM",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.49,
                    "hc-middle-y": 0.48,
                    "hc-key": "kz-am",
                    "hc-a2": "AM",
                    "labelrank": "4",
                    "hasc": "KZ.AM",
                    "alt-name": "Akmolin|Akmolinsk|Tselinograd",
                    "woe-id": "2345996",
                    "subregion": null,
                    "fips": "KZ03",
                    "postal-code": "AM",
                    "name": t('region.akmola.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "69.8519",
                    "woe-name": "Aqmola",
                    "latitude": "51.928",
                    "woe-label": "Aqmola, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                4743,
                                8079
                            ],
                            [
                                4680,
                                8055
                            ],
                            [
                                4611,
                                8047
                            ],
                            [
                                4541,
                                8018
                            ],
                            [
                                4502,
                                8053
                            ],
                            [
                                4514,
                                8099
                            ],
                            [
                                4485,
                                8118
                            ],
                            [
                                4408,
                                8107
                            ],
                            [
                                4313,
                                8134
                            ],
                            [
                                4270,
                                8172
                            ],
                            [
                                4243,
                                8171
                            ],
                            [
                                4202,
                                8215
                            ],
                            [
                                4147,
                                8182
                            ],
                            [
                                4112,
                                8179
                            ],
                            [
                                4109,
                                8242
                            ],
                            [
                                4062,
                                8310
                            ],
                            [
                                4055,
                                8343
                            ],
                            [
                                4078,
                                8383
                            ],
                            [
                                4092,
                                8447
                            ],
                            [
                                4035,
                                8496
                            ],
                            [
                                4039,
                                8517
                            ],
                            [
                                4109,
                                8530
                            ],
                            [
                                4149,
                                8567
                            ],
                            [
                                4175,
                                8647
                            ],
                            [
                                4196,
                                8668
                            ],
                            [
                                4201,
                                8747
                            ],
                            [
                                4249,
                                8735
                            ],
                            [
                                4269,
                                8710
                            ],
                            [
                                4357,
                                8718
                            ],
                            [
                                4370,
                                8693
                            ],
                            [
                                4491,
                                8678
                            ],
                            [
                                4572,
                                8688
                            ],
                            [
                                4576,
                                8740
                            ],
                            [
                                4638,
                                8737
                            ],
                            [
                                4725,
                                8698
                            ],
                            [
                                4778,
                                8749
                            ],
                            [
                                4774,
                                8788
                            ],
                            [
                                4840,
                                8810
                            ],
                            [
                                4871,
                                8853
                            ],
                            [
                                4945,
                                8889
                            ],
                            [
                                4934,
                                8948
                            ],
                            [
                                4963,
                                9002
                            ],
                            [
                                4936,
                                9049
                            ],
                            [
                                4873,
                                9106
                            ],
                            [
                                4957,
                                9162
                            ],
                            [
                                4947,
                                9187
                            ],
                            [
                                5016,
                                9184
                            ],
                            [
                                5044,
                                9203
                            ],
                            [
                                5090,
                                9169
                            ],
                            [
                                5160,
                                9208
                            ],
                            [
                                5230,
                                9190
                            ],
                            [
                                5241,
                                9137
                            ],
                            [
                                5292,
                                9140
                            ],
                            [
                                5279,
                                9092
                            ],
                            [
                                5330,
                                9093
                            ],
                            [
                                5391,
                                9048
                            ],
                            [
                                5428,
                                9104
                            ],
                            [
                                5531,
                                9110
                            ],
                            [
                                5541,
                                9080
                            ],
                            [
                                5598,
                                9066
                            ],
                            [
                                5676,
                                9098
                            ],
                            [
                                5734,
                                9032
                            ],
                            [
                                5709,
                                8966
                            ],
                            [
                                5760,
                                8930
                            ],
                            [
                                5844,
                                8928
                            ],
                            [
                                5898,
                                8959
                            ],
                            [
                                5995,
                                8968
                            ],
                            [
                                6018,
                                8960
                            ],
                            [
                                6036,
                                8876
                            ],
                            [
                                6173,
                                8842
                            ],
                            [
                                6221,
                                8812
                            ],
                            [
                                6303,
                                8806
                            ],
                            [
                                6319,
                                8771
                            ],
                            [
                                6326,
                                8571
                            ],
                            [
                                6285,
                                8543
                            ],
                            [
                                6268,
                                8471
                            ],
                            [
                                6319,
                                8475
                            ],
                            [
                                6384,
                                8440
                            ],
                            [
                                6272,
                                8396
                            ],
                            [
                                6236,
                                8341
                            ],
                            [
                                6186,
                                8347
                            ],
                            [
                                6117,
                                8330
                            ],
                            [
                                6142,
                                8282
                            ],
                            [
                                6171,
                                8301
                            ],
                            [
                                6208,
                                8286
                            ],
                            [
                                6167,
                                8253
                            ],
                            [
                                6105,
                                8234
                            ],
                            [
                                6065,
                                8197
                            ],
                            [
                                6020,
                                8205
                            ],
                            [
                                5987,
                                8158
                            ],
                            [
                                5925,
                                8138
                            ],
                            [
                                5928,
                                8099
                            ],
                            [
                                5858,
                                8084
                            ],
                            [
                                5854,
                                8047
                            ],
                            [
                                5783,
                                8053
                            ],
                            [
                                5742,
                                8041
                            ],
                            [
                                5765,
                                8129
                            ],
                            [
                                5684,
                                8168
                            ],
                            [
                                5626,
                                8111
                            ],
                            [
                                5502,
                                8047
                            ],
                            [
                                5486,
                                7978
                            ],
                            [
                                5464,
                                7996
                            ],
                            [
                                5428,
                                7984
                            ],
                            [
                                5412,
                                7928
                            ],
                            [
                                5326,
                                7898
                            ],
                            [
                                5336,
                                7954
                            ],
                            [
                                5315,
                                7980
                            ],
                            [
                                5230,
                                7965
                            ],
                            [
                                5183,
                                7968
                            ],
                            [
                                5158,
                                8012
                            ],
                            [
                                5116,
                                8018
                            ],
                            [
                                5071,
                                7959
                            ],
                            [
                                5025,
                                7943
                            ],
                            [
                                4936,
                                7968
                            ],
                            [
                                4980,
                                8108
                            ],
                            [
                                4982,
                                8146
                            ],
                            [
                                4924,
                                8165
                            ],
                            [
                                4820,
                                8117
                            ],
                            [
                                4726,
                                8116
                            ],
                            [
                                4743,
                                8079
                            ]
                        ],
                        [
                            [
                                5655,
                                8249
                            ],
                            [
                                5676,
                                8308
                            ],
                            [
                                5628,
                                8357
                            ],
                            [
                                5598,
                                8353
                            ],
                            [
                                5581,
                                8306
                            ],
                            [
                                5639,
                                8243
                            ],
                            [
                                5655,
                                8249
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.ZM",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.46,
                    "hc-middle-y": 0.43,
                    "hc-key": "kz-zm",
                    "hc-a2": "ZM",
                    "labelrank": "4",
                    "hasc": "KZ.ZM",
                    "alt-name": "Dzhambul",
                    "woe-id": "2345983",
                    "subregion": null,
                    "fips": "KZ17",
                    "postal-code": "ZM",
                    "name": t('region.zhambyl.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "72.4888",
                    "woe-name": "Zhambyl",
                    "latitude": "44.3152",
                    "woe-label": "Zhambyl, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                6792,
                                5550
                            ],
                            [
                                6749,
                                5508
                            ],
                            [
                                6625,
                                5522
                            ],
                            [
                                6541,
                                5563
                            ],
                            [
                                6501,
                                5570
                            ],
                            [
                                6460,
                                5607
                            ],
                            [
                                6359,
                                5655
                            ],
                            [
                                6364,
                                5633
                            ],
                            [
                                6302,
                                5640
                            ],
                            [
                                6286,
                                5612
                            ],
                            [
                                6214,
                                5590
                            ],
                            [
                                6177,
                                5537
                            ],
                            [
                                6180,
                                5504
                            ],
                            [
                                6155,
                                5439
                            ],
                            [
                                6180,
                                5385
                            ],
                            [
                                6133,
                                5387
                            ],
                            [
                                6130,
                                5408
                            ],
                            [
                                6077,
                                5426
                            ],
                            [
                                6004,
                                5428
                            ],
                            [
                                5973,
                                5459
                            ],
                            [
                                5907,
                                5469
                            ],
                            [
                                5858,
                                5494
                            ],
                            [
                                5808,
                                5490
                            ],
                            [
                                5740,
                                5517
                            ],
                            [
                                5670,
                                5493
                            ],
                            [
                                5622,
                                5505
                            ],
                            [
                                5554,
                                5467
                            ],
                            [
                                5548,
                                5439
                            ],
                            [
                                5516,
                                5430
                            ],
                            [
                                5485,
                                5359
                            ],
                            [
                                5365,
                                5466
                            ],
                            [
                                5320,
                                5493
                            ],
                            [
                                5317,
                                5565
                            ],
                            [
                                5277,
                                5621
                            ],
                            [
                                5163,
                                5655
                            ],
                            [
                                5124,
                                5703
                            ],
                            [
                                5154,
                                5742
                            ],
                            [
                                5218,
                                5913
                            ],
                            [
                                5225,
                                5949
                            ],
                            [
                                5197,
                                6109
                            ],
                            [
                                5121,
                                6347
                            ],
                            [
                                5062,
                                6480
                            ],
                            [
                                5029,
                                6528
                            ],
                            [
                                6361,
                                6534
                            ],
                            [
                                6327,
                                6475
                            ],
                            [
                                6320,
                                6395
                            ],
                            [
                                6337,
                                6308
                            ],
                            [
                                6271,
                                6304
                            ],
                            [
                                6262,
                                6276
                            ],
                            [
                                6285,
                                6245
                            ],
                            [
                                6337,
                                6239
                            ],
                            [
                                6353,
                                6189
                            ],
                            [
                                6455,
                                6106
                            ],
                            [
                                6474,
                                6027
                            ],
                            [
                                6513,
                                5995
                            ],
                            [
                                6572,
                                5988
                            ],
                            [
                                6617,
                                5965
                            ],
                            [
                                6664,
                                5919
                            ],
                            [
                                6650,
                                5853
                            ],
                            [
                                6582,
                                5752
                            ],
                            [
                                6691,
                                5721
                            ],
                            [
                                6656,
                                5666
                            ],
                            [
                                6674,
                                5621
                            ],
                            [
                                6750,
                                5576
                            ],
                            [
                                6732,
                                5564
                            ],
                            [
                                6792,
                                5550
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.EK",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.41,
                    "hc-middle-y": 0.42,
                    "hc-key": "kz-ek",
                    "hc-a2": "EK",
                    "labelrank": "4",
                    "hasc": "KZ.EK",
                    "alt-name": "Shyghys Qazaqstan|Vostochno-Kazakhstan",
                    "woe-id": "20070175",
                    "subregion": null,
                    "fips": "KZ15",
                    "postal-code": "EK",
                    "name": t('region.east-kaz.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "81.9768",
                    "woe-name": "East Kazakhstan",
                    "latitude": "48.3405",
                    "woe-label": "Shyghys Qazaqstan, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                7303,
                                7973
                            ],
                            [
                                7417,
                                7931
                            ],
                            [
                                7500,
                                7912
                            ],
                            [
                                7552,
                                7957
                            ],
                            [
                                7592,
                                8025
                            ],
                            [
                                7565,
                                8064
                            ],
                            [
                                7557,
                                8147
                            ],
                            [
                                7446,
                                8217
                            ],
                            [
                                7403,
                                8283
                            ],
                            [
                                7482,
                                8330
                            ],
                            [
                                7505,
                                8324
                            ],
                            [
                                7576,
                                8356
                            ],
                            [
                                7591,
                                8405
                            ],
                            [
                                7636,
                                8405
                            ],
                            [
                                7721,
                                8493
                            ],
                            [
                                7765,
                                8425
                            ],
                            [
                                7903,
                                8177
                            ],
                            [
                                8022,
                                8237
                            ],
                            [
                                8015,
                                8311
                            ],
                            [
                                8065,
                                8325
                            ],
                            [
                                8087,
                                8358
                            ],
                            [
                                8210,
                                8299
                            ],
                            [
                                8187,
                                8233
                            ],
                            [
                                8278,
                                8237
                            ],
                            [
                                8293,
                                8157
                            ],
                            [
                                8374,
                                8176
                            ],
                            [
                                8490,
                                8150
                            ],
                            [
                                8563,
                                8151
                            ],
                            [
                                8622,
                                8185
                            ],
                            [
                                8640,
                                8219
                            ],
                            [
                                8696,
                                8210
                            ],
                            [
                                8731,
                                8249
                            ],
                            [
                                8818,
                                8249
                            ],
                            [
                                8920,
                                8205
                            ],
                            [
                                8962,
                                8142
                            ],
                            [
                                8995,
                                8121
                            ],
                            [
                                9021,
                                8074
                            ],
                            [
                                9034,
                                7993
                            ],
                            [
                                9227,
                                7929
                            ],
                            [
                                9222,
                                7871
                            ],
                            [
                                9242,
                                7863
                            ],
                            [
                                9304,
                                7758
                            ],
                            [
                                9392,
                                7771
                            ],
                            [
                                9481,
                                7728
                            ],
                            [
                                9529,
                                7737
                            ],
                            [
                                9546,
                                7718
                            ],
                            [
                                9572,
                                7759
                            ],
                            [
                                9603,
                                7773
                            ],
                            [
                                9661,
                                7832
                            ],
                            [
                                9698,
                                7828
                            ],
                            [
                                9705,
                                7797
                            ],
                            [
                                9657,
                                7760
                            ],
                            [
                                9718,
                                7733
                            ],
                            [
                                9720,
                                7707
                            ],
                            [
                                9772,
                                7644
                            ],
                            [
                                9823,
                                7637
                            ],
                            [
                                9851,
                                7588
                            ],
                            [
                                9796,
                                7603
                            ],
                            [
                                9735,
                                7595
                            ],
                            [
                                9693,
                                7555
                            ],
                            [
                                9709,
                                7504
                            ],
                            [
                                9697,
                                7457
                            ],
                            [
                                9649,
                                7397
                            ],
                            [
                                9588,
                                7385
                            ],
                            [
                                9550,
                                7360
                            ],
                            [
                                9442,
                                7356
                            ],
                            [
                                9389,
                                7266
                            ],
                            [
                                9371,
                                7191
                            ],
                            [
                                9392,
                                7091
                            ],
                            [
                                9388,
                                7057
                            ],
                            [
                                9412,
                                7010
                            ],
                            [
                                9409,
                                6951
                            ],
                            [
                                9382,
                                6941
                            ],
                            [
                                9366,
                                6899
                            ],
                            [
                                9288,
                                6893
                            ],
                            [
                                9211,
                                6832
                            ],
                            [
                                9172,
                                6821
                            ],
                            [
                                9144,
                                6876
                            ],
                            [
                                9010,
                                6879
                            ],
                            [
                                8943,
                                6873
                            ],
                            [
                                8842,
                                6904
                            ],
                            [
                                8742,
                                6952
                            ],
                            [
                                8706,
                                6947
                            ],
                            [
                                8699,
                                6862
                            ],
                            [
                                8660,
                                6792
                            ],
                            [
                                8616,
                                6658
                            ],
                            [
                                8588,
                                6614
                            ],
                            [
                                8567,
                                6516
                            ],
                            [
                                8516,
                                6401
                            ],
                            [
                                8470,
                                6412
                            ],
                            [
                                8474,
                                6446
                            ],
                            [
                                8414,
                                6570
                            ],
                            [
                                8343,
                                6652
                            ],
                            [
                                8332,
                                6678
                            ],
                            [
                                8215,
                                6728
                            ],
                            [
                                8113,
                                6745
                            ],
                            [
                                7998,
                                6793
                            ],
                            [
                                7976,
                                6820
                            ],
                            [
                                7910,
                                6841
                            ],
                            [
                                7770,
                                6835
                            ],
                            [
                                7722,
                                6892
                            ],
                            [
                                7588,
                                6905
                            ],
                            [
                                7570,
                                6927
                            ],
                            [
                                7447,
                                6984
                            ],
                            [
                                7403,
                                6953
                            ],
                            [
                                7386,
                                6969
                            ],
                            [
                                7335,
                                6942
                            ],
                            [
                                7263,
                                6940
                            ],
                            [
                                7193,
                                6936
                            ],
                            [
                                7179,
                                6911
                            ],
                            [
                                7124,
                                6924
                            ],
                            [
                                7076,
                                6964
                            ],
                            [
                                7104,
                                7014
                            ],
                            [
                                7151,
                                7025
                            ],
                            [
                                7128,
                                7092
                            ],
                            [
                                7152,
                                7171
                            ],
                            [
                                7181,
                                7225
                            ],
                            [
                                7217,
                                7242
                            ],
                            [
                                7154,
                                7268
                            ],
                            [
                                7174,
                                7303
                            ],
                            [
                                7123,
                                7313
                            ],
                            [
                                7089,
                                7348
                            ],
                            [
                                7114,
                                7383
                            ],
                            [
                                7142,
                                7384
                            ],
                            [
                                7201,
                                7426
                            ],
                            [
                                7205,
                                7496
                            ],
                            [
                                7101,
                                7492
                            ],
                            [
                                7078,
                                7553
                            ],
                            [
                                7121,
                                7577
                            ],
                            [
                                7010,
                                7679
                            ],
                            [
                                7047,
                                7727
                            ],
                            [
                                7154,
                                7780
                            ],
                            [
                                7158,
                                7860
                            ],
                            [
                                7228,
                                7898
                            ],
                            [
                                7303,
                                7973
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.AR",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.71,
                    "hc-middle-y": 0.45,
                    "hc-key": "kz-ar",
                    "hc-a2": "AR",
                    "labelrank": "6",
                    "hasc": "KZ.AR",
                    "alt-name": "Ateransk|Gur'yev",
                    "woe-id": "2345986",
                    "subregion": null,
                    "fips": "KZ06",
                    "postal-code": "AR",
                    "name": t('region.atyrau.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "51.7585",
                    "woe-name": "Atyrau",
                    "latitude": "47.7744",
                    "woe-label": "Atyrau, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                696,
                                6472
                            ],
                            [
                                756,
                                6555
                            ],
                            [
                                775,
                                6639
                            ],
                            [
                                752,
                                6730
                            ],
                            [
                                783,
                                6787
                            ],
                            [
                                761,
                                6794
                            ],
                            [
                                747,
                                6848
                            ],
                            [
                                712,
                                6867
                            ],
                            [
                                631,
                                6865
                            ],
                            [
                                589,
                                6882
                            ],
                            [
                                562,
                                6846
                            ],
                            [
                                521,
                                6843
                            ],
                            [
                                531,
                                6817
                            ],
                            [
                                468,
                                6845
                            ],
                            [
                                405,
                                6853
                            ],
                            [
                                335,
                                6902
                            ],
                            [
                                258,
                                6922
                            ],
                            [
                                164,
                                6895
                            ],
                            [
                                100,
                                6860
                            ],
                            [
                                97,
                                6837
                            ],
                            [
                                47,
                                6842
                            ],
                            [
                                3,
                                6795
                            ],
                            [
                                -19,
                                6798
                            ],
                            [
                                -55,
                                6760
                            ],
                            [
                                -112,
                                6728
                            ],
                            [
                                -164,
                                6742
                            ],
                            [
                                -163,
                                6721
                            ],
                            [
                                -246,
                                6735
                            ],
                            [
                                -225,
                                6707
                            ],
                            [
                                -280,
                                6686
                            ],
                            [
                                -269,
                                6657
                            ],
                            [
                                -408,
                                6731
                            ],
                            [
                                -452,
                                6737
                            ],
                            [
                                -474,
                                6768
                            ],
                            [
                                -447,
                                6802
                            ],
                            [
                                -392,
                                6776
                            ],
                            [
                                -328,
                                6804
                            ],
                            [
                                -410,
                                6915
                            ],
                            [
                                -456,
                                7019
                            ],
                            [
                                -499,
                                7047
                            ],
                            [
                                -549,
                                7121
                            ],
                            [
                                -583,
                                7140
                            ],
                            [
                                -688,
                                7139
                            ],
                            [
                                -745,
                                7162
                            ],
                            [
                                -765,
                                7111
                            ],
                            [
                                -829,
                                7157
                            ],
                            [
                                -819,
                                7177
                            ],
                            [
                                -849,
                                7213
                            ],
                            [
                                -810,
                                7242
                            ],
                            [
                                -833,
                                7252
                            ],
                            [
                                -831,
                                7300
                            ],
                            [
                                -354,
                                7239
                            ],
                            [
                                -215,
                                7197
                            ],
                            [
                                -208,
                                7223
                            ],
                            [
                                -87,
                                7232
                            ],
                            [
                                129,
                                7361
                            ],
                            [
                                188,
                                7382
                            ],
                            [
                                243,
                                7432
                            ],
                            [
                                300,
                                7443
                            ],
                            [
                                422,
                                7427
                            ],
                            [
                                417,
                                7389
                            ],
                            [
                                504,
                                7371
                            ],
                            [
                                514,
                                7382
                            ],
                            [
                                607,
                                7356
                            ],
                            [
                                633,
                                7418
                            ],
                            [
                                672,
                                7471
                            ],
                            [
                                670,
                                7511
                            ],
                            [
                                710,
                                7554
                            ],
                            [
                                819,
                                7550
                            ],
                            [
                                912,
                                7622
                            ],
                            [
                                974,
                                7579
                            ],
                            [
                                993,
                                7602
                            ],
                            [
                                1013,
                                7560
                            ],
                            [
                                1018,
                                7462
                            ],
                            [
                                1116,
                                7442
                            ],
                            [
                                1152,
                                7495
                            ],
                            [
                                1211,
                                7470
                            ],
                            [
                                1224,
                                7432
                            ],
                            [
                                1210,
                                7363
                            ],
                            [
                                1231,
                                7249
                            ],
                            [
                                1257,
                                7222
                            ],
                            [
                                1284,
                                7099
                            ],
                            [
                                1264,
                                6933
                            ],
                            [
                                1342,
                                6812
                            ],
                            [
                                1396,
                                6768
                            ],
                            [
                                1602,
                                6700
                            ],
                            [
                                1656,
                                6577
                            ],
                            [
                                1565,
                                6593
                            ],
                            [
                                1541,
                                6617
                            ],
                            [
                                1485,
                                6627
                            ],
                            [
                                1484,
                                6659
                            ],
                            [
                                1444,
                                6667
                            ],
                            [
                                1391,
                                6708
                            ],
                            [
                                1330,
                                6663
                            ],
                            [
                                1239,
                                6659
                            ],
                            [
                                985,
                                6611
                            ],
                            [
                                918,
                                6539
                            ],
                            [
                                934,
                                6523
                            ],
                            [
                                876,
                                6491
                            ],
                            [
                                744,
                                6462
                            ],
                            [
                                696,
                                6472
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.MG",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.49,
                    "hc-middle-y": 0.48,
                    "hc-key": "kz-mg",
                    "hc-a2": "MG",
                    "labelrank": "4",
                    "hasc": "KZ.MG",
                    "alt-name": "Mangistau|Mangyshlak",
                    "woe-id": "2345991",
                    "subregion": null,
                    "fips": "KZ09",
                    "postal-code": "MG",
                    "name": t('region.mangystau.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "53.8538",
                    "woe-name": "Mangghystau",
                    "latitude": "44.0351",
                    "woe-label": "Mangghystau, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                696,
                                6472
                            ],
                            [
                                744,
                                6462
                            ],
                            [
                                876,
                                6491
                            ],
                            [
                                934,
                                6523
                            ],
                            [
                                918,
                                6539
                            ],
                            [
                                985,
                                6611
                            ],
                            [
                                1239,
                                6659
                            ],
                            [
                                1330,
                                6663
                            ],
                            [
                                1391,
                                6708
                            ],
                            [
                                1444,
                                6667
                            ],
                            [
                                1484,
                                6659
                            ],
                            [
                                1485,
                                6627
                            ],
                            [
                                1541,
                                6617
                            ],
                            [
                                1565,
                                6593
                            ],
                            [
                                1656,
                                6577
                            ],
                            [
                                1674,
                                6533
                            ],
                            [
                                1718,
                                6272
                            ],
                            [
                                1524,
                                6217
                            ],
                            [
                                1524,
                                5036
                            ],
                            [
                                1433,
                                5018
                            ],
                            [
                                1379,
                                5026
                            ],
                            [
                                1325,
                                5083
                            ],
                            [
                                1251,
                                5186
                            ],
                            [
                                1240,
                                5229
                            ],
                            [
                                1195,
                                5266
                            ],
                            [
                                1051,
                                5352
                            ],
                            [
                                1011,
                                5361
                            ],
                            [
                                843,
                                5333
                            ],
                            [
                                728,
                                5291
                            ],
                            [
                                584,
                                5171
                            ],
                            [
                                596,
                                5232
                            ],
                            [
                                574,
                                5280
                            ],
                            [
                                627,
                                5361
                            ],
                            [
                                656,
                                5437
                            ],
                            [
                                657,
                                5484
                            ],
                            [
                                593,
                                5515
                            ],
                            [
                                540,
                                5506
                            ],
                            [
                                512,
                                5534
                            ],
                            [
                                450,
                                5517
                            ],
                            [
                                429,
                                5536
                            ],
                            [
                                375,
                                5632
                            ],
                            [
                                275,
                                5620
                            ],
                            [
                                287,
                                5713
                            ],
                            [
                                274,
                                5750
                            ],
                            [
                                240,
                                5775
                            ],
                            [
                                197,
                                5867
                            ],
                            [
                                163,
                                5906
                            ],
                            [
                                161,
                                5955
                            ],
                            [
                                121,
                                5979
                            ],
                            [
                                28,
                                5994
                            ],
                            [
                                -3,
                                6020
                            ],
                            [
                                -1,
                                6084
                            ],
                            [
                                16,
                                6106
                            ],
                            [
                                68,
                                6097
                            ],
                            [
                                174,
                                6095
                            ],
                            [
                                240,
                                6051
                            ],
                            [
                                281,
                                6073
                            ],
                            [
                                345,
                                6059
                            ],
                            [
                                312,
                                6092
                            ],
                            [
                                287,
                                6087
                            ],
                            [
                                255,
                                6134
                            ],
                            [
                                194,
                                6169
                            ],
                            [
                                191,
                                6212
                            ],
                            [
                                254,
                                6241
                            ],
                            [
                                307,
                                6328
                            ],
                            [
                                412,
                                6352
                            ],
                            [
                                456,
                                6341
                            ],
                            [
                                605,
                                6353
                            ],
                            [
                                627,
                                6393
                            ],
                            [
                                654,
                                6352
                            ],
                            [
                                618,
                                6351
                            ],
                            [
                                709,
                                6322
                            ],
                            [
                                762,
                                6318
                            ],
                            [
                                804,
                                6334
                            ],
                            [
                                664,
                                6392
                            ],
                            [
                                666,
                                6429
                            ],
                            [
                                696,
                                6472
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.AA",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.44,
                    "hc-middle-y": 0.41,
                    "hc-key": "kz-aa",
                    "hc-a2": "AA",
                    "labelrank": "6",
                    "hasc": "KZ.AA",
                    "alt-name": "Alma-Ata|Alma-Atinskaya Oblast'|Almatinskaya Oblast'",
                    "woe-id": "20070180",
                    "subregion": null,
                    "fips": "KZ01",
                    "postal-code": "AA",
                    "name": t('region.almaty.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "78.2246",
                    "woe-name": "Almaty",
                    "latitude": "45.0707",
                    "woe-label": "Almaty, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                6792,
                                5550
                            ],
                            [
                                6732,
                                5564
                            ],
                            [
                                6750,
                                5576
                            ],
                            [
                                6674,
                                5621
                            ],
                            [
                                6656,
                                5666
                            ],
                            [
                                6691,
                                5721
                            ],
                            [
                                6582,
                                5752
                            ],
                            [
                                6650,
                                5853
                            ],
                            [
                                6664,
                                5919
                            ],
                            [
                                6617,
                                5965
                            ],
                            [
                                6572,
                                5988
                            ],
                            [
                                6513,
                                5995
                            ],
                            [
                                6474,
                                6027
                            ],
                            [
                                6455,
                                6106
                            ],
                            [
                                6353,
                                6189
                            ],
                            [
                                6337,
                                6239
                            ],
                            [
                                6285,
                                6245
                            ],
                            [
                                6262,
                                6276
                            ],
                            [
                                6271,
                                6304
                            ],
                            [
                                6337,
                                6308
                            ],
                            [
                                6320,
                                6395
                            ],
                            [
                                6327,
                                6475
                            ],
                            [
                                6361,
                                6534
                            ],
                            [
                                6514,
                                6681
                            ],
                            [
                                6684,
                                6774
                            ],
                            [
                                6815,
                                6778
                            ],
                            [
                                6951,
                                6769
                            ],
                            [
                                6981,
                                6752
                            ],
                            [
                                7035,
                                6776
                            ],
                            [
                                7114,
                                6764
                            ],
                            [
                                7151,
                                6730
                            ],
                            [
                                7190,
                                6754
                            ],
                            [
                                7268,
                                6773
                            ],
                            [
                                7263,
                                6940
                            ],
                            [
                                7335,
                                6942
                            ],
                            [
                                7386,
                                6969
                            ],
                            [
                                7403,
                                6953
                            ],
                            [
                                7447,
                                6984
                            ],
                            [
                                7570,
                                6927
                            ],
                            [
                                7588,
                                6905
                            ],
                            [
                                7722,
                                6892
                            ],
                            [
                                7770,
                                6835
                            ],
                            [
                                7910,
                                6841
                            ],
                            [
                                7976,
                                6820
                            ],
                            [
                                7998,
                                6793
                            ],
                            [
                                8113,
                                6745
                            ],
                            [
                                8215,
                                6728
                            ],
                            [
                                8332,
                                6678
                            ],
                            [
                                8343,
                                6652
                            ],
                            [
                                8414,
                                6570
                            ],
                            [
                                8474,
                                6446
                            ],
                            [
                                8470,
                                6412
                            ],
                            [
                                8516,
                                6401
                            ],
                            [
                                8533,
                                6377
                            ],
                            [
                                8600,
                                6362
                            ],
                            [
                                8592,
                                6277
                            ],
                            [
                                8563,
                                6257
                            ],
                            [
                                8515,
                                6294
                            ],
                            [
                                8424,
                                6267
                            ],
                            [
                                8386,
                                6281
                            ],
                            [
                                8368,
                                6330
                            ],
                            [
                                8132,
                                6261
                            ],
                            [
                                8091,
                                6266
                            ],
                            [
                                8013,
                                6238
                            ],
                            [
                                7922,
                                6225
                            ],
                            [
                                7868,
                                6188
                            ],
                            [
                                7903,
                                6152
                            ],
                            [
                                7963,
                                6160
                            ],
                            [
                                8032,
                                6133
                            ],
                            [
                                8000,
                                6106
                            ],
                            [
                                7994,
                                6029
                            ],
                            [
                                8005,
                                5981
                            ],
                            [
                                7997,
                                5927
                            ],
                            [
                                8032,
                                5864
                            ],
                            [
                                8095,
                                5718
                            ],
                            [
                                8076,
                                5675
                            ],
                            [
                                8101,
                                5663
                            ],
                            [
                                8115,
                                5612
                            ],
                            [
                                8058,
                                5609
                            ],
                            [
                                8003,
                                5580
                            ],
                            [
                                8053,
                                5538
                            ],
                            [
                                7966,
                                5503
                            ],
                            [
                                7943,
                                5450
                            ],
                            [
                                7977,
                                5327
                            ],
                            [
                                7961,
                                5311
                            ],
                            [
                                7884,
                                5386
                            ],
                            [
                                7753,
                                5400
                            ],
                            [
                                7704,
                                5452
                            ],
                            [
                                7679,
                                5503
                            ],
                            [
                                7648,
                                5492
                            ],
                            [
                                7557,
                                5508
                            ],
                            [
                                7506,
                                5530
                            ],
                            [
                                7382,
                                5524
                            ],
                            [
                                7350,
                                5535
                            ],
                            [
                                7216,
                                5545
                            ],
                            [
                                7160,
                                5542
                            ],
                            [
                                7097,
                                5567
                            ],
                            [
                                7026,
                                5542
                            ],
                            [
                                6958,
                                5535
                            ],
                            [
                                6860,
                                5549
                            ],
                            [
                                6792,
                                5550
                            ]
                        ],
                        [
                            [
                                7109,
                                5642
                            ],
                            [
                                7117,
                                5692
                            ],
                            [
                                7083,
                                5688
                            ],
                            [
                                7058,
                                5658
                            ],
                            [
                                7067,
                                5635
                            ],
                            [
                                7109,
                                5642
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.AT",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.46,
                    "hc-middle-y": 0.47,
                    "hc-key": "kz-at",
                    "hc-a2": "AT",
                    "labelrank": "6",
                    "hasc": "KZ.AT",
                    "alt-name": "Aktyubinsk",
                    "woe-id": "2345980",
                    "subregion": null,
                    "fips": "KZ04",
                    "postal-code": "AT",
                    "name": t('region.aktobe.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "58.9373",
                    "woe-name": "Aqtöbe",
                    "latitude": "48.0288",
                    "woe-label": "Aqtobe, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "MultiPolygon",
                    "coordinates": [
                        [
                            [
                                [
                                    2335,
                                    6477
                                ],
                                [
                                    2335,
                                    6477
                                ],
                                [
                                    2332,
                                    6460
                                ],
                                [
                                    2336,
                                    6447
                                ],
                                [
                                    2342,
                                    6326
                                ],
                                [
                                    2259,
                                    6374
                                ],
                                [
                                    2315,
                                    6427
                                ],
                                [
                                    2335,
                                    6477
                                ]
                            ]
                        ],
                        [
                            [
                                [
                                    1144,
                                    8087
                                ],
                                [
                                    1178,
                                    8112
                                ],
                                [
                                    1168,
                                    8211
                                ],
                                [
                                    1132,
                                    8226
                                ],
                                [
                                    1168,
                                    8261
                                ],
                                [
                                    1236,
                                    8221
                                ],
                                [
                                    1277,
                                    8211
                                ],
                                [
                                    1287,
                                    8180
                                ],
                                [
                                    1346,
                                    8134
                                ],
                                [
                                    1395,
                                    8128
                                ],
                                [
                                    1440,
                                    8087
                                ],
                                [
                                    1551,
                                    8155
                                ],
                                [
                                    1577,
                                    8219
                                ],
                                [
                                    1619,
                                    8215
                                ],
                                [
                                    1665,
                                    8275
                                ],
                                [
                                    1713,
                                    8241
                                ],
                                [
                                    1715,
                                    8274
                                ],
                                [
                                    1760,
                                    8270
                                ],
                                [
                                    1840,
                                    8284
                                ],
                                [
                                    1889,
                                    8211
                                ],
                                [
                                    1979,
                                    8215
                                ],
                                [
                                    2000,
                                    8293
                                ],
                                [
                                    2099,
                                    8271
                                ],
                                [
                                    2143,
                                    8304
                                ],
                                [
                                    2167,
                                    8274
                                ],
                                [
                                    2219,
                                    8260
                                ],
                                [
                                    2213,
                                    8204
                                ],
                                [
                                    2307,
                                    8139
                                ],
                                [
                                    2443,
                                    8122
                                ],
                                [
                                    2466,
                                    8068
                                ],
                                [
                                    2533,
                                    8088
                                ],
                                [
                                    2598,
                                    8200
                                ],
                                [
                                    2629,
                                    8197
                                ],
                                [
                                    2672,
                                    8141
                                ],
                                [
                                    2784,
                                    8130
                                ],
                                [
                                    2957,
                                    8175
                                ],
                                [
                                    2976,
                                    8208
                                ],
                                [
                                    2995,
                                    8307
                                ],
                                [
                                    3030,
                                    8344
                                ],
                                [
                                    3090,
                                    8355
                                ],
                                [
                                    3132,
                                    8274
                                ],
                                [
                                    3165,
                                    8290
                                ],
                                [
                                    3202,
                                    8265
                                ],
                                [
                                    3187,
                                    8232
                                ],
                                [
                                    3224,
                                    8199
                                ],
                                [
                                    3205,
                                    8165
                                ],
                                [
                                    3242,
                                    8138
                                ],
                                [
                                    3266,
                                    8055
                                ],
                                [
                                    3308,
                                    7980
                                ],
                                [
                                    3360,
                                    7911
                                ],
                                [
                                    3366,
                                    7867
                                ],
                                [
                                    3314,
                                    7871
                                ],
                                [
                                    3286,
                                    7853
                                ],
                                [
                                    3234,
                                    7765
                                ],
                                [
                                    3244,
                                    7737
                                ],
                                [
                                    3209,
                                    7739
                                ],
                                [
                                    3202,
                                    7711
                                ],
                                [
                                    3253,
                                    7637
                                ],
                                [
                                    3223,
                                    7616
                                ],
                                [
                                    3243,
                                    7576
                                ],
                                [
                                    3300,
                                    7517
                                ],
                                [
                                    3398,
                                    7512
                                ],
                                [
                                    3397,
                                    7453
                                ],
                                [
                                    3565,
                                    7378
                                ],
                                [
                                    3647,
                                    7269
                                ],
                                [
                                    3709,
                                    7177
                                ],
                                [
                                    3683,
                                    7152
                                ],
                                [
                                    3348,
                                    6943
                                ],
                                [
                                    3243,
                                    6965
                                ],
                                [
                                    3209,
                                    7031
                                ],
                                [
                                    3137,
                                    7073
                                ],
                                [
                                    3086,
                                    7143
                                ],
                                [
                                    3011,
                                    7142
                                ],
                                [
                                    2945,
                                    7128
                                ],
                                [
                                    2887,
                                    7059
                                ],
                                [
                                    2863,
                                    7003
                                ],
                                [
                                    2796,
                                    6915
                                ],
                                [
                                    2736,
                                    6919
                                ],
                                [
                                    2702,
                                    6856
                                ],
                                [
                                    2638,
                                    6843
                                ],
                                [
                                    2572,
                                    6801
                                ],
                                [
                                    2505,
                                    6741
                                ],
                                [
                                    2357,
                                    6570
                                ],
                                [
                                    2347,
                                    6534
                                ],
                                [
                                    2318,
                                    6543
                                ],
                                [
                                    2259,
                                    6510
                                ],
                                [
                                    2229,
                                    6417
                                ],
                                [
                                    2203,
                                    6403
                                ],
                                [
                                    1923,
                                    6330
                                ],
                                [
                                    1718,
                                    6272
                                ],
                                [
                                    1674,
                                    6533
                                ],
                                [
                                    1656,
                                    6577
                                ],
                                [
                                    1602,
                                    6700
                                ],
                                [
                                    1396,
                                    6768
                                ],
                                [
                                    1342,
                                    6812
                                ],
                                [
                                    1264,
                                    6933
                                ],
                                [
                                    1284,
                                    7099
                                ],
                                [
                                    1257,
                                    7222
                                ],
                                [
                                    1231,
                                    7249
                                ],
                                [
                                    1210,
                                    7363
                                ],
                                [
                                    1224,
                                    7432
                                ],
                                [
                                    1211,
                                    7470
                                ],
                                [
                                    1152,
                                    7495
                                ],
                                [
                                    1116,
                                    7442
                                ],
                                [
                                    1018,
                                    7462
                                ],
                                [
                                    1013,
                                    7560
                                ],
                                [
                                    993,
                                    7602
                                ],
                                [
                                    974,
                                    7579
                                ],
                                [
                                    912,
                                    7622
                                ],
                                [
                                    936,
                                    7720
                                ],
                                [
                                    1000,
                                    7771
                                ],
                                [
                                    1046,
                                    7769
                                ],
                                [
                                    1119,
                                    7839
                                ],
                                [
                                    1145,
                                    7914
                                ],
                                [
                                    1111,
                                    7955
                                ],
                                [
                                    1103,
                                    8027
                                ],
                                [
                                    1144,
                                    8087
                                ]
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.WK",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.59,
                    "hc-middle-y": 0.48,
                    "hc-key": "kz-wk",
                    "hc-a2": "WK",
                    "labelrank": "4",
                    "hasc": "KZ.WK",
                    "alt-name": "Ural'sk",
                    "woe-id": "2345998",
                    "subregion": null,
                    "fips": "KZ07",
                    "postal-code": "WK",
                    "name": t('region.west-kaz.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "50.5145",
                    "woe-name": "West Kazakhstan",
                    "latitude": "49.8909",
                    "woe-label": "Batys Qazaqstan, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                912,
                                7622
                            ],
                            [
                                819,
                                7550
                            ],
                            [
                                710,
                                7554
                            ],
                            [
                                670,
                                7511
                            ],
                            [
                                672,
                                7471
                            ],
                            [
                                633,
                                7418
                            ],
                            [
                                607,
                                7356
                            ],
                            [
                                514,
                                7382
                            ],
                            [
                                504,
                                7371
                            ],
                            [
                                417,
                                7389
                            ],
                            [
                                422,
                                7427
                            ],
                            [
                                300,
                                7443
                            ],
                            [
                                243,
                                7432
                            ],
                            [
                                188,
                                7382
                            ],
                            [
                                129,
                                7361
                            ],
                            [
                                -87,
                                7232
                            ],
                            [
                                -208,
                                7223
                            ],
                            [
                                -215,
                                7197
                            ],
                            [
                                -354,
                                7239
                            ],
                            [
                                -831,
                                7300
                            ],
                            [
                                -840,
                                7312
                            ],
                            [
                                -999,
                                7357
                            ],
                            [
                                -926,
                                7529
                            ],
                            [
                                -855,
                                7592
                            ],
                            [
                                -853,
                                7628
                            ],
                            [
                                -920,
                                7673
                            ],
                            [
                                -887,
                                7841
                            ],
                            [
                                -872,
                                7863
                            ],
                            [
                                -814,
                                7885
                            ],
                            [
                                -779,
                                7918
                            ],
                            [
                                -782,
                                7998
                            ],
                            [
                                -713,
                                8060
                            ],
                            [
                                -695,
                                8056
                            ],
                            [
                                -597,
                                7966
                            ],
                            [
                                -531,
                                7856
                            ],
                            [
                                -484,
                                7838
                            ],
                            [
                                -387,
                                7880
                            ],
                            [
                                -360,
                                7910
                            ],
                            [
                                -409,
                                8019
                            ],
                            [
                                -416,
                                8104
                            ],
                            [
                                -433,
                                8128
                            ],
                            [
                                -374,
                                8110
                            ],
                            [
                                -291,
                                8175
                            ],
                            [
                                -221,
                                8198
                            ],
                            [
                                -237,
                                8239
                            ],
                            [
                                -217,
                                8287
                            ],
                            [
                                -122,
                                8287
                            ],
                            [
                                -67,
                                8332
                            ],
                            [
                                29,
                                8365
                            ],
                            [
                                32,
                                8397
                            ],
                            [
                                74,
                                8413
                            ],
                            [
                                91,
                                8475
                            ],
                            [
                                146,
                                8462
                            ],
                            [
                                140,
                                8519
                            ],
                            [
                                182,
                                8491
                            ],
                            [
                                264,
                                8493
                            ],
                            [
                                301,
                                8473
                            ],
                            [
                                266,
                                8443
                            ],
                            [
                                283,
                                8417
                            ],
                            [
                                351,
                                8439
                            ],
                            [
                                374,
                                8410
                            ],
                            [
                                410,
                                8425
                            ],
                            [
                                405,
                                8460
                            ],
                            [
                                433,
                                8488
                            ],
                            [
                                492,
                                8483
                            ],
                            [
                                556,
                                8520
                            ],
                            [
                                602,
                                8420
                            ],
                            [
                                648,
                                8413
                            ],
                            [
                                675,
                                8430
                            ],
                            [
                                718,
                                8411
                            ],
                            [
                                743,
                                8424
                            ],
                            [
                                825,
                                8428
                            ],
                            [
                                897,
                                8382
                            ],
                            [
                                912,
                                8329
                            ],
                            [
                                982,
                                8317
                            ],
                            [
                                1028,
                                8285
                            ],
                            [
                                1046,
                                8240
                            ],
                            [
                                1126,
                                8200
                            ],
                            [
                                1100,
                                8118
                            ],
                            [
                                1144,
                                8087
                            ],
                            [
                                1103,
                                8027
                            ],
                            [
                                1111,
                                7955
                            ],
                            [
                                1145,
                                7914
                            ],
                            [
                                1119,
                                7839
                            ],
                            [
                                1046,
                                7769
                            ],
                            [
                                1000,
                                7771
                            ],
                            [
                                936,
                                7720
                            ],
                            [
                                912,
                                7622
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.SK",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.48,
                    "hc-middle-y": 0.70,
                    "hc-key": "kz-sk",
                    "hc-a2": "SK",
                    "labelrank": "4",
                    "hasc": "KZ.SK",
                    "alt-name": "Chimkent",
                    "woe-id": "2345982",
                    "subregion": null,
                    "fips": "KZ10",
                    "postal-code": "SK",
                    "name": t('region.south-kaz.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "68.7533",
                    "woe-name": "South Kazakhstan",
                    "latitude": "42.7187",
                    "woe-label": "Ongtustik Qazaqstan, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                5029,
                                6528
                            ],
                            [
                                5062,
                                6480
                            ],
                            [
                                5121,
                                6347
                            ],
                            [
                                5197,
                                6109
                            ],
                            [
                                5225,
                                5949
                            ],
                            [
                                5218,
                                5913
                            ],
                            [
                                5154,
                                5742
                            ],
                            [
                                5124,
                                5703
                            ],
                            [
                                5163,
                                5655
                            ],
                            [
                                5277,
                                5621
                            ],
                            [
                                5317,
                                5565
                            ],
                            [
                                5320,
                                5493
                            ],
                            [
                                5365,
                                5466
                            ],
                            [
                                5485,
                                5359
                            ],
                            [
                                5501,
                                5330
                            ],
                            [
                                5444,
                                5314
                            ],
                            [
                                5411,
                                5259
                            ],
                            [
                                5370,
                                5281
                            ],
                            [
                                5333,
                                5262
                            ],
                            [
                                5285,
                                5202
                            ],
                            [
                                5226,
                                5160
                            ],
                            [
                                5149,
                                5145
                            ],
                            [
                                5088,
                                5106
                            ],
                            [
                                5087,
                                5082
                            ],
                            [
                                5041,
                                5079
                            ],
                            [
                                4992,
                                5050
                            ],
                            [
                                4994,
                                5004
                            ],
                            [
                                4916,
                                4954
                            ],
                            [
                                4869,
                                4907
                            ],
                            [
                                4875,
                                4808
                            ],
                            [
                                4840,
                                4803
                            ],
                            [
                                4715,
                                4875
                            ],
                            [
                                4739,
                                4894
                            ],
                            [
                                4749,
                                4955
                            ],
                            [
                                4727,
                                4948
                            ],
                            [
                                4701,
                                4997
                            ],
                            [
                                4403,
                                4979
                            ],
                            [
                                4369,
                                4997
                            ],
                            [
                                4330,
                                5168
                            ],
                            [
                                4320,
                                5249
                            ],
                            [
                                4191,
                                5250
                            ],
                            [
                                4190,
                                5370
                            ],
                            [
                                4235,
                                5363
                            ],
                            [
                                4318,
                                5435
                            ],
                            [
                                4382,
                                5445
                            ],
                            [
                                4439,
                                5490
                            ],
                            [
                                4568,
                                5566
                            ],
                            [
                                4698,
                                5622
                            ],
                            [
                                4682,
                                5674
                            ],
                            [
                                4651,
                                5687
                            ],
                            [
                                4674,
                                5706
                            ],
                            [
                                4701,
                                5798
                            ],
                            [
                                4729,
                                5785
                            ],
                            [
                                4730,
                                5844
                            ],
                            [
                                4772,
                                5863
                            ],
                            [
                                4772,
                                5884
                            ],
                            [
                                4709,
                                5926
                            ],
                            [
                                4682,
                                5963
                            ],
                            [
                                4613,
                                5994
                            ],
                            [
                                4610,
                                6243
                            ],
                            [
                                4530,
                                6302
                            ],
                            [
                                4548,
                                6419
                            ],
                            [
                                4568,
                                6449
                            ],
                            [
                                4529,
                                6503
                            ],
                            [
                                4525,
                                6535
                            ],
                            [
                                5029,
                                6528
                            ]
                        ]
                    ]
                }
            },
            {
                "type": "Feature",
                "id": "KZ.QG",
                "properties": {
                    "hc-group": "admin1",
                    "hc-middle-x": 0.57,
                    "hc-middle-y": 0.58,
                    "hc-key": "kz-qg",
                    "hc-a2": "QG",
                    "labelrank": "4",
                    "hasc": "KZ.QG",
                    "alt-name": "Karaganda|Karagandinskaya Oblast'",
                    "woe-id": "20070178",
                    "subregion": null,
                    "fips": "KZ12",
                    "postal-code": "QG",
                    "name": t('region.qaragandy.short'),
                    "country": "Kazakhstan",
                    "type-en": "Region",
                    "region": null,
                    "longitude": "70.1925",
                    "woe-name": "Qaraghandy",
                    "latitude": "48.0823",
                    "woe-label": "Qaraghandy, KZ, Kazakhstan",
                    "type": "Oblasy"
                },
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                5029,
                                6528
                            ],
                            [
                                4525,
                                6535
                            ],
                            [
                                4518,
                                6568
                            ],
                            [
                                4447,
                                6567
                            ],
                            [
                                4068,
                                6645
                            ],
                            [
                                4012,
                                6668
                            ],
                            [
                                3947,
                                6718
                            ],
                            [
                                3924,
                                6720
                            ],
                            [
                                3607,
                                6831
                            ],
                            [
                                3549,
                                6837
                            ],
                            [
                                3445,
                                6869
                            ],
                            [
                                3376,
                                6908
                            ],
                            [
                                3297,
                                6898
                            ],
                            [
                                3348,
                                6943
                            ],
                            [
                                3683,
                                7152
                            ],
                            [
                                3709,
                                7177
                            ],
                            [
                                3647,
                                7269
                            ],
                            [
                                3711,
                                7320
                            ],
                            [
                                3713,
                                7355
                            ],
                            [
                                3801,
                                7389
                            ],
                            [
                                3790,
                                7440
                            ],
                            [
                                3821,
                                7441
                            ],
                            [
                                3852,
                                7504
                            ],
                            [
                                3940,
                                7516
                            ],
                            [
                                4060,
                                7501
                            ],
                            [
                                4116,
                                7511
                            ],
                            [
                                4176,
                                7553
                            ],
                            [
                                4229,
                                7559
                            ],
                            [
                                4364,
                                7672
                            ],
                            [
                                4592,
                                7845
                            ],
                            [
                                4655,
                                7913
                            ],
                            [
                                4653,
                                7969
                            ],
                            [
                                4747,
                                7995
                            ],
                            [
                                4790,
                                8046
                            ],
                            [
                                4743,
                                8079
                            ],
                            [
                                4726,
                                8116
                            ],
                            [
                                4820,
                                8117
                            ],
                            [
                                4924,
                                8165
                            ],
                            [
                                4982,
                                8146
                            ],
                            [
                                4980,
                                8108
                            ],
                            [
                                4936,
                                7968
                            ],
                            [
                                5025,
                                7943
                            ],
                            [
                                5071,
                                7959
                            ],
                            [
                                5116,
                                8018
                            ],
                            [
                                5158,
                                8012
                            ],
                            [
                                5183,
                                7968
                            ],
                            [
                                5230,
                                7965
                            ],
                            [
                                5315,
                                7980
                            ],
                            [
                                5336,
                                7954
                            ],
                            [
                                5326,
                                7898
                            ],
                            [
                                5412,
                                7928
                            ],
                            [
                                5428,
                                7984
                            ],
                            [
                                5464,
                                7996
                            ],
                            [
                                5486,
                                7978
                            ],
                            [
                                5502,
                                8047
                            ],
                            [
                                5626,
                                8111
                            ],
                            [
                                5684,
                                8168
                            ],
                            [
                                5765,
                                8129
                            ],
                            [
                                5742,
                                8041
                            ],
                            [
                                5783,
                                8053
                            ],
                            [
                                5854,
                                8047
                            ],
                            [
                                5858,
                                8084
                            ],
                            [
                                5928,
                                8099
                            ],
                            [
                                5925,
                                8138
                            ],
                            [
                                5987,
                                8158
                            ],
                            [
                                6020,
                                8205
                            ],
                            [
                                6065,
                                8197
                            ],
                            [
                                6105,
                                8234
                            ],
                            [
                                6167,
                                8253
                            ],
                            [
                                6208,
                                8286
                            ],
                            [
                                6171,
                                8301
                            ],
                            [
                                6142,
                                8282
                            ],
                            [
                                6117,
                                8330
                            ],
                            [
                                6186,
                                8347
                            ],
                            [
                                6236,
                                8341
                            ],
                            [
                                6321,
                                8314
                            ],
                            [
                                6337,
                                8264
                            ],
                            [
                                6305,
                                8127
                            ],
                            [
                                6333,
                                8104
                            ],
                            [
                                6431,
                                8125
                            ],
                            [
                                6487,
                                8103
                            ],
                            [
                                6502,
                                8058
                            ],
                            [
                                6526,
                                8076
                            ],
                            [
                                6564,
                                8052
                            ],
                            [
                                6620,
                                7982
                            ],
                            [
                                6548,
                                7934
                            ],
                            [
                                6588,
                                7904
                            ],
                            [
                                6677,
                                7955
                            ],
                            [
                                6751,
                                7955
                            ],
                            [
                                6890,
                                7981
                            ],
                            [
                                6922,
                                7969
                            ],
                            [
                                6940,
                                7996
                            ],
                            [
                                7030,
                                7996
                            ],
                            [
                                7046,
                                8073
                            ],
                            [
                                7103,
                                8124
                            ],
                            [
                                7274,
                                8063
                            ],
                            [
                                7287,
                                7983
                            ],
                            [
                                7303,
                                7973
                            ],
                            [
                                7228,
                                7898
                            ],
                            [
                                7158,
                                7860
                            ],
                            [
                                7154,
                                7780
                            ],
                            [
                                7047,
                                7727
                            ],
                            [
                                7010,
                                7679
                            ],
                            [
                                7121,
                                7577
                            ],
                            [
                                7078,
                                7553
                            ],
                            [
                                7101,
                                7492
                            ],
                            [
                                7205,
                                7496
                            ],
                            [
                                7201,
                                7426
                            ],
                            [
                                7142,
                                7384
                            ],
                            [
                                7114,
                                7383
                            ],
                            [
                                7089,
                                7348
                            ],
                            [
                                7123,
                                7313
                            ],
                            [
                                7174,
                                7303
                            ],
                            [
                                7154,
                                7268
                            ],
                            [
                                7217,
                                7242
                            ],
                            [
                                7181,
                                7225
                            ],
                            [
                                7152,
                                7171
                            ],
                            [
                                7128,
                                7092
                            ],
                            [
                                7151,
                                7025
                            ],
                            [
                                7104,
                                7014
                            ],
                            [
                                7076,
                                6964
                            ],
                            [
                                7124,
                                6924
                            ],
                            [
                                7179,
                                6911
                            ],
                            [
                                7193,
                                6936
                            ],
                            [
                                7263,
                                6940
                            ],
                            [
                                7268,
                                6773
                            ],
                            [
                                7190,
                                6754
                            ],
                            [
                                7151,
                                6730
                            ],
                            [
                                7114,
                                6764
                            ],
                            [
                                7035,
                                6776
                            ],
                            [
                                6981,
                                6752
                            ],
                            [
                                6951,
                                6769
                            ],
                            [
                                6815,
                                6778
                            ],
                            [
                                6684,
                                6774
                            ],
                            [
                                6514,
                                6681
                            ],
                            [
                                6361,
                                6534
                            ],
                            [
                                5029,
                                6528
                            ]
                        ]
                    ]
                }
            }
        ]
    }

    return kazakhstan;
};

export default useKazakhstan;